export const INITIAL_COMPACT_COLS = [
    "PRIORITY",
    "EVENT_LOCATION",
    "CFS_TEXT",
    "DISPATCH_AREA",
    "EVENT_NUMBER",
    "ASSIGNED_UNITS"
];

export const DEFAULT_COL_MIN_HEIGHT = 63;
export const DEFAULT_AS_COL_WIDTH = 160;

export const MUTATION_OBSERVER_OPT = {
    config: {
        attributes: true,
        attributeFilter: ['style'],
    },
};

export const RECT_WIDTH_RESIZE_STEP = 18;
